module.exports = __webpack_public_path__ + "static/images/trending-up-circle.86b3ecf17b52ac6d76b4271d8582ff55.svg";